// extracted by mini-css-extract-plugin
export default {"active":"-cm_0506adab"};